export const AND = 'AND'
export const OR = 'OR'

export const FRAGMENT_BOX_WIDTH = 292
export const FRAGMENT_BOX_WIDTH_SMALL = FRAGMENT_BOX_WIDTH - 30
export const FRAGMENT_BOX_WIDTH_MINI = 32

export const FRAGMENT_BOX_HEIGHT = 28

export const FRAGMENT_BOX_HEIGHT_SMALL = 28
export const FRAGMENT_BOX_HEIGHT_MEDIUM = 44
export const FRAGMENT_BOX_HEIGHT_LARGE = 60

export const FRAGMENT_BOX_HEIGHT_MAP = {
  small: FRAGMENT_BOX_HEIGHT_SMALL,
  medium: FRAGMENT_BOX_HEIGHT_MEDIUM,
  large: FRAGMENT_BOX_HEIGHT_LARGE,
  mini: FRAGMENT_BOX_HEIGHT_SMALL,
}

export const REF_NO_WIDTH = 32
export const ENABLED_WIDTH = 72

export const DESCRIPTION_WIDTH_DEFAULT = 188
export const DESCRIPTION_WIDTH_SMALL = DESCRIPTION_WIDTH_DEFAULT - REF_NO_WIDTH
export const DESCRIPTION_WIDTH_SIMPLE_DEFAULT =
  FRAGMENT_BOX_WIDTH - REF_NO_WIDTH
export const DESCRIPTION_WIDTH_SIMPLE_SMALL =
  DESCRIPTION_WIDTH_SIMPLE_DEFAULT - REF_NO_WIDTH

export const BORDER_RADIUS_DEFAULT = 0
export const BORDER_RADIUS_INDIVIDUAL = 4
export const BORDER_RADIUS_LARGE = 8

export const BORDER_WIDTH_DEFAULT = 1
export const BORDER_WIDTH_LARGE = 2

// Lines
export const CURVE_RADIUS = 7
export const RIGHT_DOWN_CURVE = `q ${CURVE_RADIUS},0 ${CURVE_RADIUS},${CURVE_RADIUS}`
export const DOWN_RIGHT_CURVE = `q 0,${CURVE_RADIUS} ${CURVE_RADIUS},${CURVE_RADIUS}`
export const RIGHT_UP_CURVE = `q ${CURVE_RADIUS},0 ${CURVE_RADIUS},-${CURVE_RADIUS}`
export const UP_RIGHT_CURVE = `q 0,-${CURVE_RADIUS} ${CURVE_RADIUS},-${CURVE_RADIUS}`
export const LEFT_DOWN_CURVE = `q -${CURVE_RADIUS},0 -${CURVE_RADIUS},${CURVE_RADIUS}`
export const DOWN_LEFT_CURVE = `q 0,${CURVE_RADIUS} -${CURVE_RADIUS},${CURVE_RADIUS}`
export const LEFT_UP_CURVE = `q -${CURVE_RADIUS},0 -${CURVE_RADIUS},-${CURVE_RADIUS}`
export const UP_LEFT_CURVE = `q 0,-${CURVE_RADIUS} -${CURVE_RADIUS},-${CURVE_RADIUS}`

export const ARROW_WIDTH = 10
export const ARROW_HEIGHT = 10

// Decision Diamond
export const DIAMOND_WIDTH = 57
export const DIAMOND_HEIGHT = 53

export const YES_NO_WIDTH = 22
export const YES_NO_HEIGHT = 16

// AND gate
export const AND_GATE_WIDTH = 30
export const AND_GATE_HEIGHT = 29

// OR gate
export const OR_GATE_WIDTH = 31
export const OR_GATE_HEIGHT = 26

export const ALERT_ICON_WIDTH = 20
export const ALERT_ICON_HEIGHT = 20
export const ALERT_ICON_PADDING = 3

export const DOMAINS_WITH_DIAGRAMS = [
  'VCD_PTC_PTO1_Release',
  'VCD_PTC_PTO2_Release',
  'VCD_PTC_PTO3_Release',
  'VCD_PTC_Nominal_Engine_Speed_Specifications',
  'VCD_PTC_PTO_W',
  'VCD_PTC_Engine_Mounted_PTO',
]

export const DOMAINS_WITH_DIAGRAM_FILTERS = [
  'VCD_PTC_Nominal_Engine_Speed_Specifications',
  'VCD_PTC_PTO_W',
]

export const SUMMARY = 'SUMMARY'
export const ALL_DOMAINS = 'ALL_DOMAINS'
export const ENGINE_SPEED_SETTINGS = 'ENGINE_SPEED_SETTINGS'

export const ALL = 'ALL'
export const PTO1 = 'PTO1'
export const PTO2 = 'PTO2'
export const PTO3 = 'PTO3'
export const EMPTO1 = 'EMPTO1'
export const EMPTO2 = 'EMPTO2'
export const EMPTO = 'EMPTO'

export const FILTERS = [ALL, PTO1, PTO2, PTO3, EMPTO1, EMPTO2]
export const SUMMARY_FILTERS = [PTO1, PTO2, EMPTO]
export const SPEED_SETTINGS_FILTERS = [PTO1, PTO2]

export const SETTINGS_SUMMARY_DIAGRAM_WIDTH = 1288

export const DRAWER_SELECT_MODE = 0
export const DRAWER_APPLY_CUSTOM_TEMPLATE = 1
export const DRAWER_APPLY_DAIMLER_TEMPLATE = 2
export const DRAWER_SAVE_TEMPLATE = 3

export const APPLY_TEMPLATE_TYPE_DAIMLER_ORGID = '7'
export const APPLY_TEMPLATE_TYPE_DAIMLER = 'daimler'
export const APPLY_TEMPLATE_TYPE_CUSTOM = 'custom'
